import { useNavigate } from "react-router-dom";
import AboutMainSection from "./AboutMainSection";
import CallToAction from "./CallToAction";
import WhyChooseUs from "./WhyChooseUs";
import Associates from "./Associates";

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="other-pages-main-section about-page-fin">
        <h2 className="other-pages-title">About Us</h2>
        <p>
          <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
            Home
          </span>{" "}
          /
          <span
            onClick={() => navigate("/about-Magnify-Advisory")}
            style={{ cursor: "pointer" }}
          >
            About us
          </span>
        </p>
      </div>
      <Associates />
      <div className="about-text-section-fin">
        <p>
          <strong>
            Welcome to Magnify Advisory: Your Trusted Financial Partner in Mumbai
          </strong>
        </p>

        <p>
          At Magnify Advisory, we believe that the right financial support can transform aspirations into reality. Whether you are buying your dream home, expanding your business, or investing in a commercial property, we are here to guide you every step of the way. Based in the heart of Mumbai, we specialize in crafting tailored loan solutions for Residential, Commercial, Mortgage, and Business needs.
        </p>

        <p>
          <strong>Our Foundation: Expertise You Can Trust</strong>
        </p>

        <p>
          Magnify Advisory is built on a legacy of deep banking expertise and unwavering ethical practices. Our company is promoted by Mr. Suresh Dubey, a retired senior banker with over two decades of distinguished service at ICICI Bank.
        </p>

        <p>
          His extensive experience spans Retail Branch Banking and the Mortgage Department, giving him unparalleled insight into customer needs, banking products, processes, operations, and credit assessment.
        </p>

        <p>
          the promoter Mr Suresh Dubey has worked for automobile, mutual fund and insurance companies before joining ICICI Bank.
        </p>

        <p>
           In his pivotal role in mortgages, Mr. Dubey handled Sales and Project Approvals, forging strong relationships with major developers and premium projects across the MMR (Mumbai Metropolitan Region). This unique network and market knowledge ensure our clients get access to the best opportunities and streamlined project approvals.
        </p>

        <p>
          <strong>Our Promise: Seamless, End-to-End Guidance</strong>
        </p>

        <p>
         We understand that navigating loan procedures can be complex. That’s why our core promise is simplicity and transparency.
        </p>

        <p>
          Dedicated Handholding: We assist you through the entire loan process – from document preparation and application submission to sanction and disbursement.
        </p>

        <p>
          Real-Time Updates: Our proprietary status tracking system allows you to check your loan application status at any stage, giving you peace of mind and clarity.
        </p>

        <p>
          <strong>Beyond Loans: A Suite of Financial Services</strong>
        </p>

        <p>
          Magnify Advisory is your one-stop destination for comprehensive financial growth. In addition to our core loan products, we provide: 
        </p>
        <p>Property Search</p>
        <p>Business Loan</p>
        <p>Home Loan</p>
        <p>Mortgage Loan</p>
        <p>Construction Funding</p>
        <p>Personal Loans</p>
        <p>Commercial Vehicle Loans</p>
        <p>Education Loans</p>
        <p>General Insurance</p>
        <p>Life Insurance</p>
        <p>Mutual Funds</p>
        <p>Redevelopment </p>
        <p>Sole Selling of entire projects.</p>
        <p>Industrial Loan</p>
        <p>Commercial Loan</p>
        <p>Property Exhibition</p>
        <p>Property Insurance</p>
        <p>Health Insurance</p>
        <p>Vehicle Insurance</p>
        <p>Loan Against Securities</p>
        <p>Car Loan</p>
        <p>Balance Transfer</p>

        <p><strong>Why Choose Magnify Advisory?</strong></p>
        <p>Promoter’s Direct Expertise: Benefit from the firsthand knowledge and ethics of a seasoned banking professional.</p>
        <p>Deep Market Connect: Unlock opportunities through our established relationships with top developers in MMR.</p>
        <p>Digital Process: Our end to end digital journey will update your loan status</p> 
        <p>Holistic Portfolio: Fulfill all your financial and asset-building needs under one roof.</p>

        <p>
          <strong>Let’s Build Your Future, Together</strong>
        </p>

      </div>

      <CallToAction />
    </>
  );
};

export default AboutPage;
